import React from 'react';
import Banner from '../elements/Banner'
import ProfilePicture from '../elements/ProfilePicture'
import BusinessName from '../elements/BusinessName'
import Social from '../components/Social'
import About from '../elements/About'
import SaveAsContact from '../components/SaveAsContact';
import Accordions from '../components/Accordions'
import ImageSwiper from '../elements/ImageSwiper'
import ClientsSwiper from '../elements/ClientsSwiper'
import CallToAction from '../elements/CallToAction'
import Share from '../elements/Share'
import Title from '../elements/Title'
import Line from '../elements/Line'
// Import your image with the correct file path
import ImageSwiperCloser from '../elements/ImageSwiperCloser';

import { bgImageSrc, bannerImageSrc, logoImageSrc, images, bgVideoImageSrc } from '../media';


import PriceList from '../images/priceList.jpeg'
import { Accordion } from 'react-headless-accordion';
import Accordion1 from '../elements/Accordion1';
import Accordion2 from '../elements/Accordion2';
import Accordion3 from '../elements/Accordion3';
import Accordion4 from '../elements/Accordion4';
import Accordion5 from '../elements/Accordion5';


const HomePage = () => {



    // const divStyle = {
    //     backgroundImage: `url(${bgImageSrc})`, // Note the closing parenthesis
    //     backgroundRepeat: 'no-repeat',
    //     backgroundSize: 'cover',
    // };

    const divStyle = {
        backgroundImage: `url(${bgImageSrc})`, // Note the closing parenthesis
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    };


    const divStyle1 = {
        backgroundImage: `url(${bgVideoImageSrc})`, // Note the closing parenthesis
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',

    };

    return (
        <div className='bg-gray-100'>
            <div className='bg-white w-full md:w-5/6 lg:w-3/4 mx-auto shadow-2xl border-card_borderColor rounded-2xl ' >

                <div style={divStyle}>
                    <Banner
                        type="rectangle"
                        image={bannerImageSrc}
                    />

                    <ProfilePicture
                        type="circleBorder"
                        image={logoImageSrc}

                    />

                    <BusinessName
                        businessName="Galia Fit"
                        businessDescription="לוחמת האנרגיה"
                    />

                    <div className='my-4 p-1 bg-transparent'></div>
                    <Social
                        phoneNumber="+972545783067"
                        phoneText="חייגו אליי"
                        whatsappNumber="+972545783067"
                        facebookUrl="https://www.facebook.com/galia.shengelof"
                        locationUrl="https://maps.app.goo.gl/uNVoCTqybGdnEKxr5"
                        wazeUrl=""
                        wazeText="נווטו אליי"
                        instagramUsername="galia__shengelof"
                        tiktokUsername=""
                        shareUrl="https://galiafit.netlify.app/"
                        type="circleBorder"

                    />


                    <SaveAsContact
                        text="שמרו אותי באנשי הקשר"
                        phoneNumber="+972545783067"
                        email="galiapop85@gmail.com"
                        firstName="Galia Fit"
                        lastName=""
                        type="rounded" />

                    <Accordion5 type="rounded" />

                    <About
                        header="קצת עליי"
                        text="ב-2016 התחלתי תואר בחינוך גופני בווינגייט, והבנתי שהייעוד שלי הוא בתחום הכושר, המחבר בין גוף לנפש. עם הזמן גיליתי שהמטרה שלי היא לסייע לנשים בגילאי 30-40, לאחר שעליתי וירדתי במשקל מספר פעמים באופן עצמאי. במהלך התואר ואחריו, אימנתי מגוון רחב של אוכלוסיות ורכשתי ידע מעמיק בתחומי הספורט והבריאות. אני מציעה כלים לשינוי מקיף - מנטלי, נפשי וגופני - שיעזרו לך להתמיד ולהשיג את מטרותייך לאורך זמן."
                        callToActionText="מזמינה אותך ליצור קשר בקליק"
                    />

                    <div style={divStyle1} className="my-8 py-8 bg-gradient-to-l from-mainRing to-secondaryRing p-4 rounded-3xl flex flex-col items-center justify-center">
                        <div data-aos="fade-zoom-in" data-aos-easing="linear" className='mt-8 text-3xl font-bold text-center text-black'>בואו נכיר</div>
                        <div data-aos="fade-zoom-in" data-aos-easing="linear" className="h-[1px] w-[260px] mx-auto mt-4 bg-white"></div>
                        <iframe
                            src="https://player.vimeo.com/video/966847126?h=6e650e7c1f"
                            width=""

                            height="550"
                            frameborder="0"
                            allow="autoplay; fullscreen"
                            allowFullScreen
                            style={{ borderRadius: '32px' }}
                            className='my-8 border-2'
                        ></iframe>
                    </div>

                    <About
                        header="על העסק"
                        text="אני מציעה אימונים קבוצתיים בקבוצות קטנות של 4-8 מתאמנות, עם דגש על הקלה בכאבי גב תחתון ושמירה על יציבה תקינה. ישנם ארבעה סוגי אימונים: האימון הכחול, האימון הצהוב, האימון הירוק והאימון האדום. מטרת האימונים היא לעזור לך להבין את היעדים שלך ולהשיג אותם בצורה הטובה ביותר, תוך תשומת לב לפרטים הקטנים. היתרונות מאימון מדויק הם רבים, ומאפשרים שיפור ניכר ומדוייק."
                        callToActionText=""
                    />



                    <p className='text-center text-2xl text-title_headerColor font-bold mt-4'>
                        סוגי האימונים מתחלקים ל 4 סגנונות
                    </p>
                    <Accordion1 type="rounded" />
                    <Accordion2 type="rounded" />
                    <Accordion3 type="rounded" />
                    <Accordion4 type="rounded" />




                </div>

                <div style={divStyle}>
                    <ImageSwiperCloser
                        type="top"
                        images={images} />
                    <ImageSwiper
                        images={images}
                        type="rounded"
                    />
                    <ImageSwiperCloser
                        type="bottom"
                        images={images} />
                </div>


                <div style={divStyle}>
                    {/* <Title
                        text="לקוחות ממליצים" /> */}

                    {/* <ClientsSwiper
                        testimonials={[
                            {
                                "text": "שובלי תודה רבה על הכל אהובה שלי עשית לי מושלם ברמות אני לא מפסיקה להתלהב!!!!😍😍 אין עלייך בעולםםםם❤️",
                                "author": "שקד"
                            },
                            {
                                "text": "תקשיבי אני לא מפסיקה להסתכל על הצפורניייםםםםםם",
                                "author": "ליאל"
                            },
                            {
                                "text": "אמאאאאאא איך ייצא! מושלם ברמות",
                                "author": "יולי"
                            },
                            {
                                "text": "שובל תודה רבה את לא מבינה איך אני מרוצה מהתוצאה את מדהימה💕",
                                "author": "ליאן"
                            },
                            {
                                "text": "תודה רבה על הציפורניים יצא מושלםםםם",
                                "author": "מעיין"
                            },
                            {
                                "text": "יפה שלי מה קורה? אני מה זה מצטערת על השעה אבל רציתי באמת להגיד לך שאת כזו אלופה שאין דברים כאלה!! יש לך עבודה מדוייקת ומהממת בדיוק כמוך!! אני עפתי על הציפורניים וחבר שלי יותר😂 את הצלחה מסחררת ע״פ דעתי ומי יתן ורק תעלי ותצליחי בכל תחום שתעסקי בו את נעימה כיף להיות בחברתך ובאמת שיהיה לך המון בהצלחה אהובתי שלי🫶🏻 לילה טוב❤️❤️",
                                "author": "בתאל"
                            },
                            {
                                "text": "אחותי יצא נדיר אני לא מפסיקה להסתכל על זה אמרו שממש מתאים לי ציפורניים אין עלייך❤️‍🔥❤️‍🔥❤️‍🔥❤️‍🔥",
                                "author": "אוריה"
                            },
                            {
                                "text": "לב שלייייי תודה רבה על הכללללל לא מובןןן מאליוווו❤️❤️❤️❤️",
                                "author": "הודיה"
                            },
                            {
                                "text": "אמלהההההה שלמות תודה על כל ההשקעה והזמןןן על זה שקיבלת אותי ככה בזמן כזה ייצא מושלם ונדיר!",
                                "author": "הילה"
                            },
                            {
                                "text": "תודה אהובה הציפורניים מהממות❤️❤️",
                                "author": "אורית"
                            },
                            {
                                "text": "תודה רבה על הציפורניים ייצא מהמםםםם",
                                "author": "טליה"
                            },
                            {
                                "text": "כבר כמעט 3 שנים שאני עושה ציפורניים אצל שובל. מעבר לזה שהיא אלופהההה!!! היא נשמה אמיתית מהכרות איתה היא עושה שמיניות באוויר בשביל לקוחות",
                                "author": "מורן"
                            }
                        ]
                        }
                    /> */}

                    <Accordions
                        header="השירותים שלי"
                        listItems={[
                            'מניקור יסודי',
                            'לק ג׳ל עם מבנה אנטומי',
                            'לק ג׳ל ללא מבנה אנטומי',
                            'בנייה באקריל',
                            'מילוי אקריל',
                            'בנייה בג׳ל',
                            'מילוי ג׳ל',
                            'לק ג׳ל רגליים',
                            'תיקון ציפורן',
                            'הסרת לק',
                            'קישוטים',
                        ]}

                        headerContact="תקשורת ושעות פעילות"
                        phoneNumber="+972545783067"
                        email="galiapop85@gmail.com"
                        activityHours={[
                            { text: "יום א'", hours: "18:00 - 22:00" },
                            { text: "יום ב'", hours: "18:00 - 19:00" },
                            { text: "יום ג'", hours: "18:00 - 22:00" },
                            { text: "יום ד'", hours: "08:30 - 10:30 ,18:00 - 22:00" },
                            { text: "יום ה'", hours: "18:00 - 22:00" },


                        ]}
                        type="rounded"
                    />
                    <Line />

                    {/* <div data-aos="fade-zoom-in" data-aos-easing="linear" data-aos-duration="500" data-aos-delay="800">
                        <h1 dir='rtl' className='text-center px-6 max-w-[600px] mx-auto'>
                            שלום לכם לקוחות יקרים! התחלתי לעבוד עם שירות לקביעת תורים, מעכשיו תוכלו להזמין אצלי תורים בפשטות ובקלות. הורידו את האפליקציה בכפתור למטה, הירשמו וחפשו לפי קוד העסק:
                            <br />
                            <span className='font-bold'> 25670</span>
                        </h1>

                    </div> */}
                    {/* <div className='shake-animation  max-w-[300px] mx-auto'>


                        <a
                            href="https://point-app.net/download/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group hover:shadow-lg hover:shadow-[#f5cec8]/60 transition ease-in-out hover:scale-105 p-1 rounded-xl bg-gradient-to-br from-[#000] via-[#333] to-[#000] hover:from-[#333] hover:via-[#000] hover:to-[#333] max-w-[300px] mx-auto flex flex-col justify-around items-center text-center border-2 border-[#f5cec8] dir-rtl"
                        >
                            <div className="px-6 py-2 backdrop-blur-xl bg-gradient-to-tr from-black to-[#333] rounded-xl font-bold h-full">
                                <span className="block text-lg mb-1 font-semibold text-[#fff] group-hover:text-[#f5cec8]">
                                    לקביעת תור דרך האפליקציה לחצי כאן
                                </span>
                                <span className="block text-lg mb-1 font-semibold text-[#f5cec8]">
                                    קוד עסק 25670
                                </span>
                                <svg
                                    className="w-6 h-6 stroke-[#f5cec8] group-hover:stroke-[#fff]"
                                    strokeWidth="1.8"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                                        strokeLinejoin="round"
                                        strokeLinecap="round"
                                    ></path>
                                </svg>
                            </div>
                        </a>

                    </div> */}

                    <div data-aos="fade-down"
                        data-aos-easing="ease-in-out">
                        {/* <Line /> */}

                        <CallToAction
                            header="לייעוץ ופרטים נוספים לחצי על הלוגו"
                            phoneNumber="+972545783067"
                            contact="whatsapp"
                            type="circle"
                            image={logoImageSrc} />

                        <Line />
                    </div>


                    <Share
                        url="https://galiafit.netlify.app/"
                        type="circleBorder"
                    />
                </div>

            </div>
        </div>

    )
}

export default HomePage